import { applyMiddleware, compose, createStore } from 'redux'
import { routerMiddleware } from 'connected-react-router'
import thunkMiddleware from 'redux-thunk'
import rootReducer from './reducers'
import rootSaga from './sagas'
import Immutable from 'immutable'
import createSagaMiddleware from 'redux-saga'

export const configureStore = (history, initialState = {}) => {
    const middleware = [
        routerMiddleware(history),
        thunkMiddleware,
    ]

    let showDevLogs = false

    if (__DEV__ && showDevLogs) {
        const createLogger = require('redux-logger')
        middleware.push(createLogger({
            stateTransformer: (state) => {
                const newState = {}
                for (const i of Object.keys(state)) {
                    if (Immutable.Iterable.isIterable(state[i])) {
                        newState[i] = state[i].toJS()
                    } else {
                        newState[i] = state[i]
                    }
                }
                return newState
            },
        }))
    }

    const sagaMiddleware = createSagaMiddleware()
    middleware.push(sagaMiddleware)

    const state = Object.keys(initialState).reduce((result, key) => {
        result[key] = Immutable.fromJS(initialState[key])
        return result
    }, {})

    let composed
    if (__DEV__ && typeof window.__REDUX_DEVTOOLS_EXTENSION__ !== 'undefined') {
        composed = compose(
            applyMiddleware(...middleware),
            window.__REDUX_DEVTOOLS_EXTENSION__()
        )
    } else {
        composed = compose(
            applyMiddleware(...middleware),
        )
    }

    const store = createStore(
        rootReducer(history),
        state,
        composed
    )

    sagaMiddleware.run(rootSaga)

    return store
}
